exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-wrap[data-v-4165e0b8]{background:#fff;margin-top:15px}.bottom-wrap .bottom-left[data-v-4165e0b8]{width:760px;padding:20px}.bottom-wrap .bottom-left ul li a[data-v-4165e0b8]{display:inline-block;color:#6b6b6b;font-size:14px;width:350px;line-height:25px}.bottom-wrap .bottom-left ul li a[data-v-4165e0b8]:hover{color:#e7735a}.bottom-wrap .bottom-left ul li:nth-child(n) a[data-v-4165e0b8]{margin-right:10px}.bottom-wrap .bottom-right[data-v-4165e0b8]{width:415px;height:185px}.bottom-wrap .bottom-right a[data-v-4165e0b8],.bottom-wrap .bottom-right img[data-v-4165e0b8]{display:block;width:inherit;height:inherit}", ""]);

// exports
